import { ChevronLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SyncBadge } from '../sync/SyncBadge';

export function Page({ title, back, actions, children }: { title: string; back?: string; actions?: React.ReactNode; children: React.ReactNode }) {
  return (
    <div className="mx-auto w-full max-w-3xl px-4 pb-28 pt-4 md:pb-10 md:pt-8">
      <header className="mb-5 flex items-center gap-2">
        {back ? (
          <Link to={back} className="focus-ring -ml-2 rounded-lg p-2 text-clinical-muted hover:text-clinical-ink" aria-label="Back">
            <ChevronLeft className="h-5 w-5" />
          </Link>
        ) : null}
        <h1 className="flex-1 text-2xl font-semibold tracking-tight">{title}</h1>
        {actions}
        <SyncBadge />
      </header>
      <div className="space-y-4">{children}</div>
    </div>
  );
}

export function Card({ title, children, className = '' }: { title?: string; children: React.ReactNode; className?: string }) {
  return (
    <section className={`rounded-xl border border-clinical-line bg-clinical-card p-4 shadow-soft ${className}`}>
      {title ? <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-clinical-muted">{title}</h2> : null}
      {children}
    </section>
  );
}
